import { api } from 'domains/api';
import { CompletedSignupMachineContext } from 'domains/signup/signupFlow/signupMachine';
import { GCLIDParameters, getGCLIDParameters } from 'domains/tracking/GCLIDtracking';
import { UTMParameters, getUTMParameters } from 'domains/tracking/UTMTracking';
import { TypeTherapyScreenerV2 } from 'types/contentful';
import { stateMapping } from 'utils/states';

type CreateLeadPayload = {
  address: {
    state: string;
  };
  ageRanges: string;

  communicationConcerns: string;

  email: string;
  receiveNewsletter: boolean;

  firstName: string;
  lastName: string;
  phone: string;

  insurance: boolean;

  leadSource: string;
} & Partial<GCLIDParameters & UTMParameters>;

type CreateLeadResponse = {
   
  Cue_Contact_ID__c: string;
  id: string;
};

export const stringifyScreenerResponses = (screener: TypeTherapyScreenerV2, responses: string[]): string => {
  let result = `Screener responses for screener ${screener.fields.ageRangeTitle}:\n\n\n`;

  screener.fields.questions.forEach(({ fields: { question } }, index) => {
    result += `${index + 1}. ${question}: ${responses[index]}\n`;
  });
  return result;
};

export const mapSignupContextToLeadPayload = (contextData: CompletedSignupMachineContext): CreateLeadPayload => {
  return {
    address: {
      state: stateMapping[contextData.contactInfo.state as keyof typeof stateMapping],
    },
    ageRanges: contextData.target,
    communicationConcerns: contextData.communicationConcerns,
    email: contextData.contactInfo.email,
    receiveNewsletter: contextData.contactInfo.receiveNewsletter,
    phone: contextData.contactInfo.phoneNumber,
    firstName: contextData.contactInfo.firstName,
    lastName: contextData.contactInfo.lastName,
    insurance: contextData.insuranceInfo.useInsurance,
    leadSource: 'Self-Referral - Web Inquiry',
    ...getUTMParameters(),
    ...getGCLIDParameters(),
  };
};

export const createSalesforceLead = (payload: CreateLeadPayload) => {
  return api.proxy.post<CreateLeadResponse>(`/salesforce/leads`, payload).then(response => {
    return response.Cue_Contact_ID__c;
  });
};
